// extracted by mini-css-extract-plugin
export default {"container":"BP-z","title":"CP-z","link":"DP-z"};